import { Text, Container } from '@mantine/core';

const NoDataFound = ({ text }: any) => {
  return (
    <>
      <Container>
        <Text>{text}</Text>
      </Container>
    </>
  );
};

export default NoDataFound;
